import { render, staticRenderFns } from "./TintImageControl.vue?vue&type=template&id=00dd7016"
import script from "./TintImageControl.vue?vue&type=script&lang=js"
export * from "./TintImageControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports